import Target from 'dashboard/components/GraphCanvasV2/target/target';

export default class QueryEditorTarget extends Target<HTMLDivElement> {
  type = 'query-editor';
}
